// extracted by mini-css-extract-plugin
export var inputContainer = "_sh-0";